const KDMenu = [
    {id: "0", value: "日K"},    
    {id: "1", value: "週K"},
    {id: "2", value: "月K"}    
  ];  
  
  export default KDMenu